module.exports = __webpack_public_path__ + "static/media/close.52f29a03.svg";